<template>
    <y-modal
        ref="Modal"
        :title="$t('button.send')"
    >
        <div slot="body">
            <y-form-field
                v-model="model"
                type="textarea"
                name="moderation_note"
            />
        </div>

        <template slot="footer">
            <div class="ta-l w-100">
                <y-button
                    class="ml5"
                    @click.prevent.native="close"
                >
                    {{ $t('button.cancel') }}
                </y-button>
                <y-button
                    color="orange"
                    @click.prevent.native="confirm"
                >
                    {{ $t('button.sure') }}
                </y-button>
            </div>
        </template>
    </y-modal>
</template>

<script>

    import { YModal, YFormField } from '@deps';

    export default {
        name: 'PostConfirmModal',

        components: {
            YModal,
            YFormField,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                model: null,
            };
        },

        methods: {

            /**
             * Remove item
             */
            confirm() {
                this.$emit('confirm', this.model);
                this.close();
            },

            /**
             * Open modal
             */
            open() {
                this.$refs.Modal.open();
            },

            /**
             * Close modal
             */
            close() {
                this.$refs.Modal.close();
                this.reset();
            },

            /**
             * Reset modal data
             */
            reset() {
                this.model = null;
            },

        },
    };
</script>
